// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/* export const environment = {
  production: true
};

export const firebaseConfig = {
  apiKey: "AIzaSyBtL2nJ4zXUpg-Sy_FSueebQkjNeRqnE6s",
  authDomain: "pruebasdemo-70037.firebaseapp.com",
  projectId: "pruebasdemo-70037",
  storageBucket: "pruebasdemo-70037.appspot.com",
  messagingSenderId: "67087218181",
  appId: "1:67087218181:web:d0d8e1c2cb673cf0d6ce6c"
}; */

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAu73yDOH6SoIwR_HcwjKmTksFYQGpeYnQ",
    authDomain: "sapiolab-48252.firebaseapp.com",
    databaseURL: "https://sapiolab-48252-default-rtdb.firebaseio.com",
    projectId: "sapiolab-48252",
    storageBucket: "sapiolab-48252.appspot.com",
    messagingSenderId: "497175897227",
    appId: "1:497175897227:web:b11645b1447417c4bbe08e",
    measurementId: "G-2BMYETGE83"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
